import { camelCase } from 'es-toolkit';

type ToCamelCase<S extends string> = S extends `${infer First}-${infer Rest}`
  ? `${First}${ToCamelCase<Capitalize<Rest>>}`
  : S;

export const toCamelCase = <S extends string>(input: S): ToCamelCase<S> => camelCase(input) as ToCamelCase<S>;
